import TemplateView from '../../../../TemplateView'
import $ from 'jquery'
import AnimatedDialogWrapper from "../../../../util/AnimatedDialogWrapper";
import ItemsList from "./ItemsList"
import Item from './Item'
import DelimiterItem from './DelimiterItem'

export const createItemObject = (value, text) => {
    return {
        value,
        text,
    }
}

export const DELIMITER_VALUE = -888

export const createDelimiterObject = () => {
    return {
        value: DELIMITER_VALUE,
        text: '',
    }
}

export default class ItemsFilter extends TemplateView {
    constructor({
        items = [],
        defaultValue = null,
        onChange = () => {},
        additionalFilterClass = '',
        additionalListClass = '',
    }) {
        super(null)

        this.state = {
            selectedValue: null,
            menuOpened: false,
        }

        this.params = {
            items,
            defaultValue,
            onChange,
            additionalFilterClass,
            additionalListClass,
        }

        this.onStatePropertyChanged('selectedValue', (selectedValue, prevSelectedValue) => {
            this.$el.toggleClass('filtered', selectedValue !== this.params.defaultValue)

            this._itemsMap[selectedValue].setState({selected: true})
            if (prevSelectedValue)
                this._itemsMap[prevSelectedValue].setState({selected: false})
        })

        this.onStatePropertyChanged('menuOpened', () => {
            this.$el.toggleClass('pressed', this.state.menuOpened)
        })

        this._itemsMap = {}
    }

    templateHtml() {
        return '<div class="userList_components_itemsFilter commonVisibleFilterButton">' +
               '    <div class="mainIcon"></div>' +
               '    <div class="downIcon"></div>' +
               '</div>'
    }

    afterRender() {
        this.$el
            .addClass(this.params.additionalFilterClass)
            .on('click', this._handleClickFilter)

        const itemEls = []
        this.params.items.forEach(({value, text}) => {
            if (value === DELIMITER_VALUE) {
                itemEls.push(new DelimiterItem())
            } else {
                const itemEl = new Item({
                    value,
                    text,
                    onClick: this._handleClickItem,
                })

                this._itemsMap[value] = itemEl
                itemEls.push(itemEl)
            }
        })
        this.list = new AnimatedDialogWrapper(null, {
            dialog: new ItemsList({
                items: itemEls
            }),
            className: 'userList_components_itemsFilter_listWrapper ' + this.params.additionalListClass,
            autoPosition: true,
            toggleMode: true,
            onHide: () => {this.setState({menuOpened: false})}
        }).init($('body'))
    }

    _handleClickItem = (val) => {
        this.list.hide()
        if (this.state.selectedValue !== val) {
            this.params.onChange(val)
        }
    }

    _handleClickFilter = () => {
        this.list.showAt(
            this.getEl(),
            {
                my: 'right top',
                at: 'right bottom',
            })
        this.setState({
            menuOpened: true,
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/itemsFilter/ItemsFilter.js